// Corner radii. Sharp by design — rectangular surfaces (cards, inputs,
// dropdowns, modals, buttons, chips) use a crisp 2px. `full` stays for
// genuinely circular elements (avatars, toggles, status dots).
export const Radii = {
  r1:   2,
  r2:   2,
  r3:   2,
  r4:   2,
  r5:   2,
  full: 999,
};
